import { Component, Input } from "@angular/core";
import { CoreIcon, CoreUtilityButton, TooltipDirective } from "@svs/angular";

@Component({
  selector: "app-sidebar-services",
  imports: [
    CoreUtilityButton,
    TooltipDirective,
    CoreIcon,
  ],
  templateUrl: "./sidebar-services.component.html",
  styleUrl: "./sidebar-services.component.scss",
})
export class SidebarServicesComponent {

  @Input({ required: true }) compactView!: boolean;

  services = [
    {
      icon: "mark_unread_chat_alt",
      text: "svsGO Nachrichten",
      link: "https://www.svs.at/svsdirekt/?contentid=10007.863367&portal=svsportal&LO=4",
    },
    {
      icon: "payments",
      text: "Beitragskonto",
      link: "https://www.svs.at/sva-vorschreibung/?contentid=10007.853115&portal=svsportal&LO=4",
    },
    {
      icon: "monitor_heart",
      text: "Gesundheitskonto",
      link: "https://www.svs.at/sva-kvleist/?contentid=10007.852327&portal=svsportal&LO=4",
    },
    {
      icon: "contract_edit",
      text: "Rechnung einreichen",
      link: "https://www.svs.at/sva-kostenersatz/?contentid=10007.843166&portal=svsportal&LO=4",
    },
    {
      icon: "upload_file",
      text: "Verordnung zur Bewilligung einreichen",
      link: "https://www.svs.at/sva-ebs/?contentid=10007.850445&portal=svsportal&LO=4",
    },
  ];

  openLink(link: string) {
    window.open(link, "_blank");
  }
}
